import type React from "react"
import type { Achievement } from "@/app/achievements/page"
import { BookOpen, Star, Calculator, Flame, Users, Lock } from "lucide-react"

interface AchievementBadgeProps {
  achievement: Achievement
}

const iconMap: Record<string, React.ComponentType<{ className?: string }>> = {
  BookOpen,
  Star,
  Calculator,
  Flame,
  Users,
}

export default function AchievementBadge({ achievement }: AchievementBadgeProps) {
  const IconComponent = achievement.isUnlocked ? iconMap[achievement.icon] : Lock

  return (
    <div
      className={`p-4 rounded-2xl text-center shadow-sm border-2 transform hover:scale-105 transition-transform ${
        achievement.isUnlocked ? "bg-white border-teal-500" : "bg-slate-50 border-slate-200 opacity-70"
      }`}
    >
      <div
        className={`w-16 h-16 rounded-full mx-auto flex items-center justify-center mb-3 ${
          achievement.isUnlocked ? "bg-teal-100" : "bg-slate-200"
        }`}
      >
        <IconComponent className={`w-8 h-8 ${achievement.isUnlocked ? "text-teal-600" : "text-slate-400"}`} />
      </div>
      <p className={`font-semibold text-sm ${achievement.isUnlocked ? "text-slate-900" : "text-slate-500"}`}>
        {achievement.name}
      </p>
      <p className={`text-xs ${achievement.isUnlocked ? "text-slate-500" : "text-slate-400"}`}>
        {achievement.description}
      </p>
    </div>
  )
}
